import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";

function Accepted({
  show,
  handleShow,
  pageName,
  actionName,
  approvedReject,
  getList,
  requireRejectReason = false,
}) {
  const [reason, setReason] = useState("");

  const handleYes = () => {
    if (requireRejectReason && actionName === "Reject" && !reason.trim()) {
      toast.error("Please enter a rejection reason.");
      return;
    }
    approvedReject(reason);
    getList();
    handleShow();
    setReason(""); // Reset reason
  };

  const handleNo = () => {
    handleShow("no");
    setReason("");
  };

  return (
    <Modal show={show} onHide={handleNo} centered>
      <div className="modal-content body-bg">
        <div className="modal-header border-0">
          <button
            type="button"
            className="btn-close"
            onClick={handleNo}
          ></button>
        </div>
        <div className="modal-body text-center mb-4">
          <h4>
            {actionName} this {pageName}?
          </h4>
          <p>
            Are you sure, you want to {actionName} this {pageName}?
          </p>
          {requireRejectReason && actionName === "Reject" && (
            <div className="text-start mt-3 mb-3 px-3">
              <label className="form-label fw-bold">Rejection Reason <span className="text-danger">*</span></label>
              <textarea
                className="form-control"
                rows="3"
                placeholder="Enter the rejection reason..."
                value={reason}
                onChange={(e) => setReason(e.target.value)}
              ></textarea>
            </div>
          )}
          <div className="view-btns">
            <button
              className="btn btn-reject btn-view mt-2"
              onClick={handleNo}
            >
              No
            </button>
            <button
              className="btn btn-accept btn-view mt-2"
              onClick={handleYes}
            >
              Yes
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default Accepted;
